const DOMAIN_PREFIX = "https";

const BASE_URLS = {
  development: `https://api.dev.app.pukaarai.com`,
  qa: `http://34.0.12.51`,
  staging: `http://34.0.12.51`,
  production: `${DOMAIN_PREFIX}://tool.pukaarai.com`,
};

const API_BASE_URL = BASE_URLS["production"]; // or "development"

const API_URLS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  VERIFY_TOKEN: `${API_BASE_URL}/auth/verify-token`,
  UPDATE_USER_INFO: `${API_BASE_URL}/auth/update-user-info`,
  UPDATE_BABY_INFO: `${API_BASE_URL}/child/update-baby-info`,
  FETCH_SUCCESSFULL_REFERRALS: `${API_BASE_URL}/auth/fetch-successfull-referrals`,
};

const CRY_ANALYSER_URLS = {
  CRY_ANALYSER_API: `${API_BASE_URL}/cry_analyser/analyse/save`,
};

const FEEDBACK_URLS = {
  SUBMIT: `${API_BASE_URL}/feedback/submit`,
};

const ASSESSMENT_URLS = {
  ASSESSMENT_QUESTION_GET: `${API_BASE_URL}/assessment/questions/get`,
  ASSESSMENT_ANSWER_SAVE: `${API_BASE_URL}/assessment/answers/save`,
};

const FOR_YOU_URLS = {
  FOR_YOU_QUESTIONS: `${API_BASE_URL}/for_you/questions`,
  FOR_YOU_ANSWERS_SAVE: `${API_BASE_URL}/for_you/answers/save`,
  FOR_YOU_CONTENT_GET: `${API_BASE_URL}/for_you/content/get`,
  FOR_YOU_CONTENT_INTERACTION: `${API_BASE_URL}/for_you/content-interaction`,
};

const EXPERTS_URLS = {
  GET_ALL_EXPERTS: `${API_BASE_URL}/expert/list/get`,
  EXPERTS_HOMEPAGE: `${API_BASE_URL}/expert/experts/homepage`,
  EXPERTS_AVAILABLE_SLOTS: `${API_BASE_URL}/expert/expert/available-slots`,
  BOOK_SLOT: `${API_BASE_URL}/expert/expert/book-slot`,
  CHANGE_SESSION_STATE: `${API_BASE_URL}/expert/expert/session/changeState`,
};

export { API_BASE_URL, API_URLS, CRY_ANALYSER_URLS, FEEDBACK_URLS, ASSESSMENT_URLS, FOR_YOU_URLS, EXPERTS_URLS };
